
  import { Vue, Component, Prop, Watch } from "vue-property-decorator";
  import ContractorsMultiselect from "@/components/autocompleteMultiselects/ContractorsMultiselect.vue";
  import FormGroupError from "@/components/form/FormGroupError.vue";

  @Component({
    components: {
      FormGroupError,
      ContractorsMultiselect
    },
  })
  export default class ValidatableEmployeesMultiselect extends Vue {
    @Prop({ type: String, required: true }) readonly error!: string;
    @Prop({ type: Array, required: true }) readonly value!: string[];
    @Prop({ type: String, default: "" }) readonly multiselectClasses!: string;
    @Prop({ type: Object, default: () => ({}) }) readonly contractorsConditions!: Record<string, any>;
    @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;
    @Prop({ type: Boolean, default: false }) readonly outerError!: boolean;

    invalid: boolean = false;
    selectedEmployeeIds: string[] = [];

    get isError(): boolean {
      return this.outerError || this.invalid;
    }

    @Watch('value', {immediate: true})
    onValueChange(employeeIds : string[]): void {
      this.selectedEmployeeIds = employeeIds;
    }

    @Watch('disabled')
    onDisabledChange(): void {
      if (this.disabled) {
        this.invalid = false;
      }
    }

    onClose(): void {
      if (this.selectedEmployeeIds.length === 0) {
        this.invalid = true;
        return;
      }
    }

    updateSelectedEmployees(employeeIds: string[]): void {
      this.selectedEmployeeIds = employeeIds;

      this.$emit("input", employeeIds);

      if (employeeIds.length === 0) {
        this.invalid = true;
        return;
      }

      this.invalid = false;
    }
  }
